import { createContext } from 'react';
import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { Conversa, Duvida, PaginationDuvidas } from 'api/Assessor/duvidas';

export interface UserAuth {
  ver: boolean;
  responder: boolean;
  alterarSituacao: boolean;
  incluirMensagem: boolean;
  relatorio: boolean;
}

interface AssessorMensagensContext {
  evento: IAssembleiasAssessorEvent | null;
  conversas: PaginationDuvidas;
  conversaAtual: Conversa | null;
  irParaConversa: (cpfUsuario: string) => void;
  atualizarMensagens: (
    successCb?: (conversas: PaginationDuvidas) => void
  ) => void;
  pesquisar: (termo: string) => void;
  filtroRespondidos: (ativar: boolean | undefined) => void;
  filtroEmResposta: (ativar: boolean | undefined) => void;
  irParaPagina: (page: number) => void;
  atualizarEvento: () => void;
  termoPesquisa?: string;
  auth?: UserAuth;
  paginaAtual: number;
  dAtual?: Duvida;
  setDAtual?: (newValue?: Duvida) => void;
}

export default createContext<AssessorMensagensContext>({
  evento: null,
  conversas: {
    elements: [],
    totalElements: 0,
    totalPages: 1,
    countMensagensPendentes: 0,
    countMensagensRespondidas: 0,
    countMensagensEmResposta: 0,
  },
  conversaAtual: null,
  irParaConversa: () => {},
  atualizarMensagens: () => {},
  pesquisar: () => {},
  filtroRespondidos: () => {},
  filtroEmResposta: () => {},
  irParaPagina: () => {},
  atualizarEvento: () => {},
  paginaAtual: 1,
  setDAtual: undefined,
  dAtual: undefined,
});
